<div
  class="message-container"
  [class.box]="this.communication().type !== this.CommunicationType.System"
  [class.is-mine]="this.communication().isMine"
  [class.intern]="this.communication().type === this.CommunicationType.Intern"
  [class.system]="this.communication().type === this.CommunicationType.System"
  [class.error]="this.communication().status === CommunicationStatus.Failed"
>
  @if (this.communication().type !== this.CommunicationType.System && this.enableReply()) {
    <div class="participant-container space-between">
      <cam-communication-participant
        [participant]="this.communication().from"
        [conversationParticipants]="this.conversationParticipants()"
      ></cam-communication-participant>
      <div class="flex-start g-space-sm">
        @if (this.communication().type === this.CommunicationType.Mail) {
          <div>
            <cam-font-icon
              type="xs"
              name="arrow-go-back-line"
              (click)="
                this.askReply.emit({
                  communication: this.communication(),
                  isForward: false,
                })
              "
            ></cam-font-icon>
          </div>
        }
        @if (this.communication().type === this.CommunicationType.Mail) {
          <div>
            <cam-font-icon
              type="xs"
              name="arrow-go-forward-line"
              (click)="
                this.askReply.emit({
                  communication: this.communication(),
                  isForward: true,
                })
              "
            ></cam-font-icon>
          </div>
        }
      </div>
    </div>
  }
  <div class="message-wrapper mb-space-xs">
    @switch (this.communication().type) {
      @case (this.CommunicationType.Mail) {
        <cam-communication-message-mail
          [communication]="this.communication()"
          [conversationParticipants]="this.conversationParticipants()"
          [taskId]="this.taskId()"
        ></cam-communication-message-mail>
      }
      @case (this.CommunicationType.Chat) {
        <cam-communication-message-chat
          [communication]="this.communication()"
          [conversationParticipants]="this.conversationParticipants()"
        ></cam-communication-message-chat>
      }
      @case (this.CommunicationType.Intern) {
        <cam-communication-message-chat
          [communication]="this.communication()"
          [conversationParticipants]="this.conversationParticipants()"
        ></cam-communication-message-chat>
      }
      @case (this.CommunicationType.System) {
        <cam-communication-message-system
          [communication]="this.communication()"
          [conversationParticipants]="this.conversationParticipants()"
        ></cam-communication-message-system>
      }
    }
    @if (this.communication().documentsIds && this.communication().documentsIds.length > 0) {
      <div class="documents-container pt-space-md">
        <cam-documents-list [documentsIds]="this.communication().documentsIds"></cam-documents-list>
      </div>
    }
  </div>
  <div class="time">
    <cam-text size="sm" color="secondary">
      <div class="align-center">
        @if (this.communication().status !== CommunicationStatus.Sent) {
          <cam-communication-status
            [value]="this.communication().status"
            (click)="this.open()"
          ></cam-communication-status>
        }
        @if (this.communication().status === CommunicationStatus.Sent) {
          <cam-time-ago [date]="this.communication().createdTime" [withHours]="true"></cam-time-ago>
        }
        @if (
          this.communication().createdByFullName &&
          (this.communication().type === this.CommunicationType.Intern ||
            this.communication().type === this.CommunicationType.System)
        ) {
          <div class="ml-space-xs">
            {{ 'communication.message.from' | translate }}
            {{ this.communication().createdByFullName }}
          </div>
        }
      </div>
    </cam-text>
  </div>
</div>

<cam-layout-full-panel
  [toggleState]="this.errorModal.open()"
  (closeEvent)="this.errorModal.open.set(false)"
  title="communication.message.system.error.title"
  type="modal"
  size="lg"
>
  @if (this.errorModal.open()) {
    <cam-communication-error-content [modalState]="this.errorModal"></cam-communication-error-content>
  }
</cam-layout-full-panel>
